export class CaseDetails {
  id: string;
  jurisdiction: string;
  case_type_id: string;
  state: string;
  created_date?: string;
  last_modified?: string;
  locked_by_user_id?: string;
  security_level?: string;
  case_data?: object;
}
